import { lazy } from "react";

export const TrashView = lazy(() => import("./TrashView"));
